import React from "react";
import Modal from "@material-ui/core/Modal";
import Button from "@material-ui/core/Button";
import { View, Text } from "ui";
import ConfigureButton from "./ConfigureButton";
import { styled } from "styles";
import _ from "lodash";
import "react-datepicker/dist/react-datepicker.css";
import DatePicker from "react-datepicker";
import TimeKeeper from "react-timekeeper";
import moment, { Moment } from "moment";

interface P {
  date: Moment;
  leftIcon: string;
  title: string;
  open?: boolean;
  time?: boolean;
  onChange?: (date: Moment) => void;

  maxDate?: Moment;
  minDate?: Moment;
}

class DateModal extends React.Component<P> {
  public static defaultProps = {
    open: false,
    time: false
  };
  public state = {
    open: false,
  };

  public handleOpen = () => {
    this.setState({ open: true });
  }

  public handleClose = () => {
    this.setState({ open: false });
  }

  public handleChange = (date: Moment) => {
    const { onChange } = this.props;
    this.setState({ date, open: false });
    if (onChange){
      onChange(date);
    }
  }

  public render() {
    const { date, maxDate, minDate } = this.props;
    let rightText = "";
    if (date) {
      if (this.props.time){
        rightText = date.format("HH:mm");
      } else {
        rightText = date.format("DD/MM/YYYY");
      }
    }

    return (
      <React.Fragment>
        <ConfigureButton
          leftIcon={this.props.leftIcon as any}
          title={this.props.title}
          onClick={this.handleOpen}
          rightText={rightText}
        />
        {this.state.open && (
          <DatePicker
            selected={date}
            onChange={this.handleChange}
            withPortal
            inline
            locale="ro"
            showTimeSelect={this.props.time}
            showTimeSelectOnly={this.props.time}
            timeIntervals={15}
            onClickOutside={this.handleClose}
            timeCaption=""
            maxDate={maxDate}
            minDate={minDate}
          />
        )}
      </React.Fragment>
    );
  }
}

export default DateModal;



// WEBPACK FOOTER //
// ./src/components/DateModal.tsx